// extracted by mini-css-extract-plugin
module.exports = {"action":"Action_action__OpoPA","primary":"Action_primary__F1pjz"};